// Módulo PURO (sin imports, testeable con Node pelado): guard contra las
// "respuestas fantasma" de axios.
//
// axios settle() RESUELVE (no rechaza) toda respuesta con status falsy — una
// acomodación para file:// que corre ANTES de validateStatus. Consecuencia en
// browser: un XHR abortado por navegación (el usuario clickeó un link con
// requests en vuelo) llega a los .then() como "éxito" con body vacío, y los
// consumidores revientan al tratarlo como datos: normalize() sobre string
// vacío (ARCADI-EP), transferLimits.find sobre no-array (ARCADI-F4).
//
// Este guard corta la clase entera en un solo punto: status 0 => rechazo
// explícito con nombre claro, que las cadenas de recuperación capturan igual
// que cualquier fallo de red.
export function rejectPhantomResponses(response) {
  if (response && response.status === 0) {
    const error = new Error('Phantom response (status 0): request aborted or blocked');
    error.isPhantomResponse = true;
    error.config = response.config;
    return Promise.reject(error);
  }
  return response;
}
